export enum EntityDefinitionLevel {
UserDefined,
Library,
Systemic,
}
